import { AWQ2O } from "../../data/OSSD/Grade10/AWQ2O";
import GradeCourseTemplate from "../../pageTemplate/GradeCourseTemplate";


export default function AWQ2OPage() {
    return (
        <div>
            <GradeCourseTemplate data={AWQ2O} />
        </div>
    )
}